import React, { useEffect, useState } from "react";
import DialogBox from "../../global/DialogBox";
import Loader from "../../global/loader/Loader";
import {
    colors,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
    } from "../../ui";
import { useDispatch,
    useSelector } from "react-redux";
import { updateBillCustomerDetails,
    updatebillHotelDetails } from "../../../store/billDetailsSlice";
import { INITIALROOMDETAIS } from "./RestBillConstants";
import { isEmpty,
    set } from "lodash";
import {
  BillStatus,
  CART_INITIAL_STATE,
  DELROOM,
  printDebugLog,
  SEARCHROOM,
  SUCCESS
} from "../../../constants/constant";
import { snpAxios } from "../../global/api";
import { INITIAL_BILL_CUSTOMER_DETAILS, INITIAL_BILL_HOTEL_DETAILS_STATE } from "../../../constants/restoConstant";
import DismissButton from "../../global/DismissButton";
import SnpButton from "../../global/SnpButton";
import { Search } from "../../ui/icons";
import { useSnpUI } from "../../global/snpComponent/SnpUiProvider";
import { use } from "react";

const HotelRoomSearchDialog = ({ showDialog, setShowDialog }) => {
  const [roomDetails, setRoomDetails] = useState(INITIAL_BILL_HOTEL_DETAILS_STATE);
  const [hotelDialogLoader, setHotelDialogLoader] = useState(false);
  const { billDetails, billHotelDetails } = useSelector((state) => state.bill);
  const storeActiveShopHash = useSelector(
    (state) => state.setActiveShopHashReducer.activeShopHash
  );
  const storeApiUrl = useSelector(
    (state) => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL
  );

  useEffect(() => {
    setRoomDetails(billHotelDetails);
  },[billHotelDetails])

  useEffect(() => {
    console.log("room details: ", roomDetails);
    
  },[])
  const {snackbar, loader} = useSnpUI();
  const dispatch = useDispatch();
  const checkRoom = () => {
    if (!isEmpty(roomDetails.roomNo)) {
      let mUrl = storeApiUrl.BACKEND_BASE_URL + SEARCHROOM;
      let data = {
        jcJson: {
          apiToken: CART_INITIAL_STATE.apiToken,
          roomNo: roomDetails.roomNo,
          shopHash: storeActiveShopHash.id,
        },
      };
      snpAxios
        .post(mUrl, data)
        .then((response) => {
          //setShowDialog(false);
          if (response.data.status === SUCCESS) {
            console.log();
            setRoomDetails({
              ...roomDetails,
              ...response.data.jcJson,
            });
            if (response.data.jcJson.roomBooked) {
              // what is the use case??
              //   setBillingData({
              //     ...listbillingData,
              //     hotelBillId: "",
              //     hotelBillNo: "",
              //   });
            }
          }
        })
        .catch((error) => {
          //setHotelDialogLoader(false);
          printDebugLog("errr ", error);
          //window.location.href = "#/error";
        });
    } else {
      snackbar.show({
        message: "Plase Enter Room Details",
        color: "red",
      });
    }
  };

    const removeRoomApi = () => {
      if (!isEmpty(roomDetails.roomNo)) {
        let mUrl = storeApiUrl.BACKEND_BASE_URL + DELROOM;
        let data = {
          jcJson: {
            apiToken: CART_INITIAL_STATE.apiToken,
            hotelBillId: billHotelDetails.hotelBillId,
            billNo: billDetails.billNo,
            shopHash: storeActiveShopHash.id,
          },
        };
        loader.show();
        snpAxios
          .post(mUrl, data)
          .then((response) => {
            loader.hide();
            if (response.data.status === SUCCESS) {
             // fetchBill(listbillingData.billNo, null);
             // why we were calling fetchBill here? need that value in response
             // possibly we need to call diapatch updateHotelBillDetails in response
              dispatch(updatebillHotelDetails(INITIAL_BILL_HOTEL_DETAILS_STATE));
              setRoomDetails(INITIAL_BILL_HOTEL_DETAILS_STATE);
            }
          })
          .catch((error) => {
            printDebugLog("errr ", error);
            //window.location.href = "#/error";
          });
      } else {

        snackbar.show({
          message: "Plase Enter Room Details before delete",
          color: "red",
        })
      }
    };
  const dialogHotelRoomContent = () => {
    return (
      <>
        <div>
            <Grid
              container
              spacing={0}
              display="flex"
              alignItems="center"
              sx={{
                m: 1,
                p: 1,
              }}
            >
              {!roomDetails.saved && (
                <Grid item md={12} xs={12} sm={12}>
                  <TextField
                    id="searchRoom"
                    name="searchRoom"
                    fullWidth
                    variant="filled"
                    size="small"
                    label="Enter Room No"
                    defaultValue={roomDetails.roomNo}
                    onChange={(e) =>
                      setRoomDetails({
                        ...roomDetails,
                        roomNo: e.target.value,
                      })
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton onClick={checkRoom}>
                            <Search />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              )}
              {roomDetails.saved && (
                <Grid item md={12} xs={12} sm={12}>
                  <Typography
                    variant="p"
                    component="div"
                    style={{
                      color: "#2f1160",
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                    }}
                  >
                    Room No :{roomDetails.roomNo}
                  </Typography>
                </Grid>
              )}
              <Grid item md={12} xs={12} sm={12}>
                <Typography
                  variant="p"
                  component="div"
                  style={{
                    color: "#2f1160",
                    whiteSpace: "pre-wrap",
                    overflowWrap: "break-word",
                  }}
                >
                  Room Book Status :
                  {roomDetails.roomBooked ? "Booked" : "Empty"}
                </Typography>
              </Grid>
              {roomDetails.custName && (
                <Grid item md={12} xs={12} sm={12}>
                  <Typography
                    variant="p"
                    component="div"
                    style={{
                      color: "#2f1160",
                      whiteSpace: "pre-wrap",
                      overflowWrap: "break-word",
                    }}
                  >
                    Customer Name :
                    {roomDetails.roomBooked ? roomDetails.custName : ""}
                  </Typography>
                </Grid>
              )}
            </Grid>
        </div>
      </>
    );
  };

  const dialogHotelRoomAction = () => {
    return (
      <>
        {!roomDetails.saved &&
          !isEmpty(roomDetails.roomNo) &&
          roomDetails.roomBooked && (
            <SnpButton
              variant="contained"
              color="primary"
              onClick={() => {
                //setHotelRoomDialog(false);
                setShowDialog(false);
                dispatch(
                  updateBillCustomerDetails({
                    custMob: roomDetails.mobNo,
                    custName: roomDetails.custName,
                    custEmail: roomDetails.emailId,
                    address: roomDetails.address,
                  })
                );

                dispatch(
                  updatebillHotelDetails({
                    hotelBillId: roomDetails.hotelBillId,
                    hotelBillNo: roomDetails.roomNo,
                    roomNo: roomDetails.roomNo,
                    saved: true,
                    roomBooked: true,
                  })
                );
                setRoomDetails({...roomDetails, saved: true});
                // setCustomerDetails({
                //   ...listbillingData,
                //   hotelBillId: roomDetails.hotelBillId,
                //   hotelBillNo: roomDetails.roomNo,
                //   custMob: roomDetails.mobNo,
                //   custName: roomDetails.custName,
                //   custEmail: roomDetails.emailId,
                //   address: roomDetails.address,
                // });

                // setCustomerInputDialog({
                //   ...customerInputDialog,
                //   custInputAdd: true, // what this means
                //   redeemRoyaltyPrice: false,
                // });
                //setIsCustDataAvailable(false);
              }}
            >
              Set
            </SnpButton>
          )}
        {!roomDetails.saved && !isEmpty(roomDetails.roomNo) && (
          <DismissButton
            variant="contained"
            color="primary"
            onClick={() => {
              setRoomDetails(INITIAL_BILL_HOTEL_DETAILS_STATE);
              dispatch(updateBillCustomerDetails(INITIAL_BILL_CUSTOMER_DETAILS));
              dispatch(updatebillHotelDetails(INITIAL_BILL_HOTEL_DETAILS_STATE));
              //   setCustomerDetails({
              //     ...listbillingData,
              //     hotelBillId: "",
              //     hotelBillNo: "",
              //     custMob: "",
              //     custName: "",
              //     custEmail: "",
              //     address: "",
              //   });
              //   setCustomerInputDialog({
              //     ...customerInputDialog,
              //     custInputAdd: false,
              //     redeemRoyaltyPrice: false,
              //   });
              //   setIsCustDataAvailable(true);
              setShowDialog(false);
            }}
          >
            Clear
          </DismissButton>
        )}
        {roomDetails.saved &&
          !isEmpty(roomDetails.roomNo) &&
          !billDetails.payLaterSignal &&
          billDetails.billStatus !== BillStatus.PAID && (
            <SnpButton
              variant="contained"
              color="primary"
              onClick={() => {
                removeRoomApi();
                setShowDialog(false);
              }}
            >
              Remove Room
            </SnpButton>
          )}
        <DismissButton
          variant="contained"
          color="primary"
          onClick={() => {
            if (!roomDetails.saved)
              setRoomDetails(INITIAL_BILL_HOTEL_DETAILS_STATE);
            setShowDialog(false);
          }}
        >
          Dismiss
        </DismissButton>
      </>
    );
  };
  return (
    <div>
      <DialogBox
        showDialog={showDialog}
        title="Room Details"
        // onClose={customerInputDialogClose}
        dialogContent={dialogHotelRoomContent()}
        dialogActions={dialogHotelRoomAction()}
      ></DialogBox>
    </div>
  );
};

export default HotelRoomSearchDialog;
